{
  "_meta": {
    "_comment": "Phase 6 Wave 3 Tasks 07+08+09+10 — products namespace VI (primary). vg-binding: PLAN:task-07 / PLAN:task-08 / PLAN:task-09 / PLAN:task-10 / P6.D-15..24 / P6.D-34 / P6.D-38 / P6.D-39 / P6.D-43..50 / P6.D-51..58 / P6.D-139 / P6.D-148 / P6.D-207 / P6.D-209 / P6.D-220",
    "locale": "vi",
    "completeness": "primary"
  },
  "editor": {
    "unsavedGuard": {
      "title": "Rời trang khi chưa lưu?",
      "body": "Bạn có thay đổi chưa lưu. Rời trang bây giờ sẽ mất các thay đổi này.",
      "stay": "Ở lại",
      "leave": "Rời & bỏ thay đổi"
    },
    "title": {
      "placeholder": "Tên sản phẩm…"
    },
    "tabs": {
      "general": "Thông tin chung",
      "variants": "Biến thể",
      "pricing": "Giá",
      "media": "Hình ảnh",
      "seo": "SEO"
    },
    "actions": {
      "save": "Lưu",
      "saving": "Đang lưu…",
      "cancel": "Huỷ",
      "publish": "Đăng bán",
      "delete": "Xoá",
      "stay": "Ở lại",
      "leave": "Rời đi",
      "unsavedTitle": "Chưa lưu thay đổi",
      "unsavedWarning": "Bạn có thay đổi chưa lưu. Rời khỏi trang sẽ mất dữ liệu.",
      "unsavedMarker": "• chưa lưu",
      "saved": "Đã lưu sản phẩm",
      "saveFailed": "Lưu thất bại",
      "noChanges": "Không có thay đổi để lưu"
    },
    "status": {
      "draft": "Nháp",
      "active": "Đang bán",
      "archived": "Lưu trữ"
    },
    "fields": {
      "name": "Tên sản phẩm",
      "description": "Mô tả",
      "descriptionPlaceholder": "Markdown được hỗ trợ…",
      "category": "Danh mục",
      "categoryReadonly": "gắn từ blueprint",
      "tags": "Thẻ",
      "tagsPlaceholder": "Thêm thẻ rồi nhấn Enter",
      "removeTag": "Xoá thẻ {{tag}}"
    },
    "changelog": {
      "banner": "Blueprint v{{latest}} đã release. Phiên bản đang dùng: v{{pinned}}.",
      "viewDiff": "Xem thay đổi"
    },
    "variant": {
      "intro": "Quản lý SKU, tồn kho và giá riêng cho từng biến thể.",
      "add": "Thêm biến thể",
      "remove": "Xoá",
      "retire": "Ngừng bán",
      "restrictedBadge": "Ngừng bán",
      "restrictedTitle": "SKU này đã được dành riêng cho merchant khác nên không đặt hàng hay chỉnh sửa được. Liên hệ quản lý tài khoản nếu cần thay đổi.",
      "size": "Kích cỡ",
      "color": "Màu",
      "sku": "SKU",
      "trackInventory": "Theo dõi tồn",
      "trackOn": "Bật",
      "trackOff": "Tắt",
      "inventory": "Tồn kho",
      "priceOverride": "Giá riêng (¢)",
      "actions": "Thao tác",
      "empty": "Chưa có biến thể. Bấm \"Thêm biến thể\" để tạo dòng đầu tiên."
    },
    "pricing": {
      "defaultsTitle": "Giá mặc định theo bậc",
      "defaultsHint": "Đơn vị: cent (¢). Áp dụng khi không có giá riêng cho cửa hàng.",
      "storesTitle": "Giá theo cửa hàng",
      "store": "Cửa hàng",
      "empty": "Chưa có cửa hàng nào kết nối.",
      "tier": {
        "titanium": "Titanium",
        "platinum": "Platinum",
        "diamond": "Diamond"
      }
    },
    "media": {
      "addByUrl": "Thêm ảnh theo URL",
      "add": "Thêm",
      "empty": "Chưa có ảnh. Dán URL để thêm.",
      "setPrimary": "Đặt làm ảnh chính"
    },
    "seo": {
      "metaTitle": "Meta title",
      "metaDescription": "Meta description",
      "slug": "Slug URL",
      "slugHint": "Chỉ chứa chữ thường, số và dấu gạch nối."
    },
    "publish": {
      "confirmTitle": "Đăng sản phẩm lên cửa hàng?",
      "confirmDesc": "Chọn các cửa hàng bạn muốn đồng bộ sản phẩm này.",
      "noStores": "Chưa kết nối cửa hàng nào."
    },
    "delete": {
      "confirmTitle": "Xoá \"{{name}}\"?",
      "confirmDesc": "Hành động này sẽ xoá sản phẩm khỏi danh sách công khai.",
      "softNote": "Đây là xoá mềm — sản phẩm có thể khôi phục trong vòng 30 ngày."
    },
    "notFound": {
      "title": "Không tìm thấy sản phẩm",
      "back": "Quay lại My Products"
    }
  },
  "myProducts": {
    "title": "Sản phẩm của tôi",
    "subtitle": "Quản lý danh mục sản phẩm và niêm yết tại các cửa hàng.",
    "fromPrice": "Từ {{price}}",
    "variantCount": "{{count}} biến thể",
    "loadMore": "Tải thêm",
    "loadingMore": "Đang tải…",
    "cta": {
      "add": "Thêm sản phẩm mới",
      "bulkImport": "Nhập hàng loạt",
      "settings": "Cài đặt sản phẩm"
    },
    "tabs": {
      "label": "Bộ lọc trạng thái",
      "all": "Tất cả",
      "active": "Đang bán",
      "draft": "Nháp",
      "archived": "Lưu trữ",
      "inactive": "Ngừng"
    },
    "filters": {
      "category": "Danh mục",
      "syncStatus": "Đồng bộ",
      "store": "Cửa hàng",
      "search": "Tìm sản phẩm…",
      "viewMode": "Chế độ hiển thị",
      "table": "Bảng",
      "grid": "Lưới",
      "allStores": "Tất cả cửa hàng",
      "baseProduct": "Mẫu gốc",
      "allBaseProducts": "Tất cả mẫu gốc",
      "searchBaseProduct": "Tìm mẫu gốc…",
      "loadingBaseProduct": "Đang tải…",
      "noBaseProduct": "Không có mẫu gốc",
      "refineSearch": "Gõ thêm để thu hẹp…"
    },
    "sort": {
      "createdDesc": "Mới nhất",
      "createdAsc": "Cũ nhất",
      "nameAsc": "Tên: A → Z",
      "nameDesc": "Tên: Z → A",
      "lastModifiedDesc": "Sửa gần đây",
      "syncStatus": "Theo trạng thái đồng bộ"
    },
    "sync": {
      "pending": "Chờ",
      "syncing": "Đang đồng bộ",
      "synced": "Đã đồng bộ",
      "failed": "Thất bại",
      "moreStores": "Còn {{n}} cửa hàng nữa"
    },
    "actions": {
      "menu": "Hành động",
      "view": "Xem",
      "edit": "Sửa",
      "duplicate": "Nhân bản",
      "publish": "Đăng lên cửa hàng",
      "archive": "Lưu trữ",
      "delete": "Xóa",
      "unarchive": "Khôi phục (về nháp)"
    },
    "bulk": {
      "selected": "Đã chọn {{count}}",
      "publish": "Đăng hàng loạt",
      "archive": "Lưu trữ hàng loạt",
      "delete": "Xóa hàng loạt",
      "clear": "Bỏ chọn",
      "confirmDeleteTitle": "Xóa sản phẩm đã chọn?",
      "confirmDeleteBody": "Bạn sắp xóa {{count}} sản phẩm. Hành động này không thể hoàn tác.",
      "confirmDeleteConfirm": "Xóa",
      "confirmDeleteCancel": "Hủy"
    },
    "empty": {
      "all": "Chưa có sản phẩm nào.",
      "active": "Chưa có sản phẩm đang bán.",
      "draft": "Chưa có sản phẩm nháp. Tạo sản phẩm mới?",
      "archived": "Chưa có sản phẩm nào được lưu trữ.",
      "cta": "Thêm sản phẩm",
      "titles": {
        "all": "Tạo sản phẩm đầu tiên của bạn",
        "draft": "Chưa có sản phẩm nháp",
        "active": "Chưa có sản phẩm đang bán",
        "archived": "Không có sản phẩm lưu trữ"
      },
      "bodies": {
        "all": "Bắt đầu bằng cách chọn một blueprint và tuỳ chỉnh thiết kế của riêng bạn — hoặc nhập hàng loạt từ file CSV.",
        "draft": "Lưu sản phẩm dở dang vào nháp để hoàn tất sau. Duyệt catalog để bắt đầu.",
        "active": "Hoàn tất một bản nháp và bấm Đăng bán để sản phẩm hiển thị tại các cửa hàng đã kết nối.",
        "archived": "Sản phẩm bị lưu trữ sẽ xuất hiện ở đây. Bạn vẫn có thể khôi phục lại bất cứ lúc nào."
      },
      "ctas": {
        "create": "Tạo sản phẩm đầu tiên",
        "browseCatalog": "Duyệt catalog",
        "publishDraft": "Đăng bản nháp đầu tiên",
        "bulkImport": "Hoặc nhập hàng loạt"
      }
    },
    "bulkImport": {
      "subtitle": "Tải lên file CSV/XLSX để tạo nhiều sản phẩm cùng lúc. Tối đa {{n}} dòng/lần.",
      "close": "Đóng",
      "dropHint": "Kéo & thả file CSV/XLSX vào đây",
      "dropSubhint": "hoặc bấm để chọn file",
      "title": {
        "upload": "Nhập sản phẩm hàng loạt",
        "preview": "Xem trước dữ liệu",
        "importing": "Đang nhập…",
        "result": "Kết quả nhập"
      },
      "actions": {
        "back": "Quay lại",
        "import": "Nhập sản phẩm",
        "cancel": "Huỷ",
        "importing": "Đang xử lý…",
        "done": "Xong"
      },
      "template": {
        "title": "Cần file mẫu?",
        "subtitle": "Tải file CSV mẫu — đã có đủ cột bắt buộc + ví dụ dữ liệu.",
        "download": "Tải file mẫu"
      },
      "preview": {
        "summary": "{{rows}} dòng · {{cols}} cột",
        "ok": "Sẵn sàng nhập",
        "invalid": "Có lỗi cần sửa",
        "tooMany": "File vượt giới hạn {{n}} dòng/lần. Hãy chia nhỏ rồi nhập lại.",
        "status": "Trạng thái",
        "rowOk": "OK",
        "rowFail": "Lỗi",
        "note": "Chỉ hiển thị 10 dòng đầu để xem trước. Phần còn lại sẽ được kiểm tra trên server."
      },
      "progress": {
        "label": "Đang nhập {{processed}}/{{total}} dòng…",
        "hint": "Vui lòng không đóng cửa sổ — quá trình nhập sẽ kết thúc trong vài giây."
      },
      "result": {
        "allOk": "Đã nhập thành công",
        "partial": "Nhập một phần",
        "allFailed": "Nhập thất bại",
        "summary": "{{succeeded}}/{{total}} dòng thành công, {{failed}} lỗi.",
        "errorsHeading": "Một vài dòng bị lỗi",
        "downloadErrors": "Tải file báo cáo lỗi",
        "rowLabel": "Dòng {{index}}"
      },
      "parseError": "Không đọc được file. Vui lòng thử lại.",
      "validation": {
        "missingColumn": "Cột bắt buộc \"{{col}}\" không có trong file.",
        "nameEmpty": "Tên sản phẩm trống.",
        "invalidPrice": "Giá không hợp lệ (\"{{raw}}\").",
        "missingBlueprint": "Thiếu blueprint_id.",
        "skuEmpty": "SKU trống.",
        "invalidSku": "SKU không hợp lệ (\"{{sku}}\") — chỉ cho phép chữ/số/. _ -",
        "duplicateSku": "SKU trùng trong file (cùng store): \"{{sku}}\"."
      }
    },
    "columns": {
      "thumbnail": "Hình",
      "name": "Tên",
      "store": "Cửa hàng",
      "storeMore": "+{{count}} cửa hàng",
      "category": "Danh mục",
      "sync": "Đồng bộ",
      "created": "Ngày tạo",
      "lastModified": "Sửa gần đây",
      "actions": ""
    },
    "publish": {
      "success": "Đã đăng \"{{name}}\" lên cửa hàng",
      "failed": "Đăng thất bại"
    },
    "archive": {
      "success": "Đã lưu trữ \"{{name}}\""
    },
    "unarchive": {
      "success": "Đã khôi phục \"{{name}}\" về nháp"
    },
    "statusChange": {
      "failed": "Cập nhật trạng thái thất bại"
    },
    "duplicate": {
      "success": "Đã nhân bản \"{{name}}\"",
      "failed": "Nhân bản thất bại"
    },
    "baseProduct": "Mẫu gốc: {{name}}",
    "delete": {
      "success": "Đã xoá \"{{name}}\"",
      "failed": "Xoá thất bại"
    },
    "lockedHint": "Sản phẩm riêng tư này không còn được chia sẻ với cửa hàng của bạn — bạn chỉ xem được, không thể tạo đơn mới."
  },
  "page": {
    "title": "Danh mục sản phẩm",
    "subtitle": "Duyệt blueprint và thêm vào cửa hàng của bạn."
  },
  "filters": {
    "searchPlaceholder": "Tìm blueprint…",
    "viewMode": "Chế độ hiển thị",
    "grid": "Lưới",
    "list": "Danh sách",
    "allCategories": "Tất cả danh mục",
    "collections": "Bộ sưu tập",
    "priceRange": "Giá",
    "min": "Tối thiểu",
    "max": "Tối đa",
    "clearAll": "Xóa tất cả",
    "totalCount": "{{total}} blueprint"
  },
  "sort": {
    "popular": "Phổ biến nhất",
    "newest": "Mới nhất",
    "priceAsc": "Giá: thấp đến cao",
    "priceDesc": "Giá: cao đến thấp",
    "nameAsc": "Tên: A → Z"
  },
  "category": {
    "apparel": "Quần áo",
    "drinkware": "Ly cốc",
    "wall-art": "Tranh treo tường",
    "accessories": "Phụ kiện",
    "stationery": "Văn phòng phẩm"
  },
  "collection": {
    "featured": "Nổi bật",
    "new-arrivals": "Hàng mới về",
    "best-sellers": "Bán chạy",
    "seasonal": "Theo mùa"
  },
  "chip": {
    "priceMin": "Từ ${{cents}}",
    "priceMax": "Đến ${{cents}}"
  },
  "card": {
    "from": "Từ",
    "view": "Xem",
    "add": "Thêm vào Sản phẩm của tôi",
    "swatches": "Màu sẵn có",
    "tierTooltip": "Giá theo tier {{tier}} của bạn",
    "added": "Đã thêm",
    "addedTooltip": "Bạn đã có sản phẩm tạo từ blueprint này. Xem trong Sản phẩm của tôi."
  },
  "badge": {
    "new": "Mới",
    "outOfStock": "Hết hàng",
    "featured": "Nổi bật"
  },
  "featured": {
    "title": "Mẫu nổi bật",
    "subtitle": "Bố cục sẵn sàng để gắn nhãn"
  },
  "empty": {
    "title": "Không có blueprint phù hợp",
    "body": "Danh mục đang được chuẩn bị. Vui lòng quay lại sau.",
    "bodyWithFilters": "Chưa có sản phẩm phù hợp. Thử bỏ filter.",
    "reset": "Xóa tất cả filter"
  },
  "errors": {
    "loadFailed": "Không tải được danh mục. Vui lòng thử lại.",
    "retry": "Thử lại"
  },
  "detail": {
    "loading": "Đang tải blueprint…",
    "breadcrumb": "Đường dẫn",
    "description": "Mô tả",
    "notFound": {
      "title": "Không tìm thấy blueprint",
      "body": "Blueprint bạn đang xem không còn khả dụng.",
      "backToCatalog": "Quay lại danh mục"
    },
    "tierPrice": {
      "title": "Giá theo bậc khách hàng",
      "yourTier": "Bậc của bạn",
      "dealBadge": "Khuyến mãi",
      "otherTierTooltip": "Giá chỉ hiển thị cho bậc của bạn",
      "noTierHint": "Chưa nạp được bậc của bạn — đăng nhập để xem giá."
    },
    "variant": {
      "title": "Biến thể",
      "color": "Màu sắc",
      "size": "Kích cỡ",
      "outOfStock": "Hết hàng",
      "empty": "Chưa có biến thể"
    },
    "printAreas": {
      "title": "Vùng in",
      "front": "Mặt trước",
      "back": "Mặt sau",
      "sleeve_left": "Tay áo trái",
      "sleeve_right": "Tay áo phải"
    },
    "print": {
      "title": "Vùng in",
      "subtitle": "Bấm vào vùng để xem kích thước",
      "mockupAlt": "Hình mockup sản phẩm",
      "printZones": "Vùng in",
      "embroideryZones": "Vùng thêu",
      "stitches": "mũi thêu",
      "maxDpi": "Tối đa",
      "maxStitches": "Mũi thêu tối đa"
    },
    "related": {
      "title": "Sản phẩm tương tự"
    },
    "cta": {
      "addToProducts": "Thêm vào My Products",
      "disabledTooltip": "Blueprint này tạm thời không thể thêm.",
      "added": "Đã thêm vào Sản phẩm của tôi",
      "addedTooltip": "Bạn đã có sản phẩm tạo từ blueprint này. Xem trong Sản phẩm của tôi.",
      "viewMine": "Xem trong Sản phẩm của tôi"
    },
    "addons": {
      "title": "Tiện ích & phụ kiện",
      "addonsLabel": "Tiện ích",
      "accessoriesLabel": "Phụ kiện",
      "required": "bắt buộc"
    },
    "gallery": {
      "thumbStrip": "Ảnh thu nhỏ",
      "openLightbox": "Mở chế độ xem toàn màn hình",
      "lightboxTitle": "Xem mockup toàn màn hình",
      "lightboxDescription": "Dùng phím mũi tên để chuyển ảnh, +/- để zoom, ESC để đóng.",
      "zoomIn": "Phóng to",
      "zoomOut": "Thu nhỏ",
      "zoomReset": "Đặt lại zoom",
      "zoomFit": "Vừa khung",
      "close": "Đóng",
      "prev": "Ảnh trước",
      "next": "Ảnh sau",
      "empty": "Không có mockup"
    },
    "versionLatest": "{{pinned}} (mới nhất: {{latest}})",
    "edit": "Chỉnh sửa",
    "media": "Hình ảnh",
    "noImage": "Chưa có ảnh",
    "primary": "Chính",
    "general": "Thông tin chung",
    "blueprint": "Blueprint",
    "category": "Danh mục",
    "blueprintVersion": "Phiên bản blueprint",
    "baseCost": "Giá cost (hệ thống → merchant)",
    "createdAt": "Tạo lúc",
    "updatedAt": "Cập nhật lúc",
    "tags": "Thẻ",
    "variants": "Biến thể",
    "size": "Size",
    "color": "Màu",
    "priceOverride": "Giá riêng",
    "inventory": "Tồn kho",
    "state": "Trạng thái",
    "retired": "Đã ẩn",
    "restricted": "Ngừng bán",
    "restrictedTitle": "SKU này đã được dành riêng cho merchant khác nên không đặt hàng được. Liên hệ quản lý tài khoản nếu cần thay đổi.",
    "activeVariant": "Đang bán",
    "pricingPerStore": "Giá bán theo cửa hàng",
    "store": "Cửa hàng",
    "sellingPrice": "Giá bán",
    "seo": "SEO",
    "metaTitle": "Meta title",
    "slug": "Slug",
    "metaDescription": "Meta description",
    "customSku": "SKU tuỳ chỉnh"
  },
  "wizard": {
    "breadcrumb": "Sản phẩm của tôi / Tạo sản phẩm mới",
    "pageTitle": "Tạo sản phẩm mới",
    "draftSaved": "Đã lưu nháp lúc {{ts}}",
    "unsavedWarning": "Bạn có thay đổi chưa lưu trong wizard. Rời đi sẽ mất dữ liệu.",
    "placeholder": "Bước này sẽ sớm được mở.",
    "title": {
      "step1": "Chọn sản phẩm",
      "step15": "Cửa hàng",
      "step2": "Biến thể & Tiện ích",
      "step3": "Thêm mockup",
      "step4": "Giá bán",
      "step5": "Xem lại & Đăng bán"
    },
    "nav": {
      "back": "Quay lại",
      "saveDraft": "Lưu nháp",
      "next": "Tiếp tục",
      "finish": "Hoàn tất",
      "saving": "Đang lưu…",
      "saveChanges": "Lưu thay đổi"
    },
    "step1": {
      "heading": "Chọn sản phẩm gốc để tuỳ chỉnh",
      "desc": "Chọn blueprint mà sản phẩm của bạn dựa vào.",
      "search": "Tìm blueprint…",
      "filter": "Tất cả danh mục",
      "empty": "Không có blueprint nào khớp với tìm kiếm.",
      "emptyHint": "Thử từ khoá hoặc danh mục khác.",
      "select": "Chọn",
      "selected": "Đã chọn",
      "selectedLabel": "Blueprint đã chọn",
      "change": "Đổi"
    },
    "step15": {
      "title": "Chọn cửa hàng đăng bán",
      "desc": "Chọn các cửa hàng sẽ nhận sản phẩm này khi đăng bán. Bạn có thể đổi sau.",
      "allStores": "Chọn tất cả",
      "noneStores": "Bỏ chọn tất cả",
      "targetStores": "Đã chọn {{count}}/{{total}}",
      "minOneRequired": "Cần ít nhất 1 cửa hàng để tiếp tục.",
      "noStores": "Bạn chưa kết nối cửa hàng nào.",
      "noStoresHint": "Cần kết nối ít nhất 1 store trước khi tạo sản phẩm.",
      "connectStore": "Kết nối cửa hàng",
      "loadFailed": "Không tải được danh sách cửa hàng. Vui lòng thử lại.",
      "disconnected": "Mất kết nối"
    },
    "step2": {
      "heading": "Cấu hình biến thể & tiện ích",
      "desc": "Chọn các tổ hợp size/màu sẽ đăng bán và các tiện ích kèm theo cho khách.",
      "noBlueprint": "Vui lòng chọn blueprint ở Bước 1 trước.",
      "loadFailed": "Không tải được biến thể của blueprint.",
      "matrixEmpty": "Blueprint này chưa có biến thể. Tiếp tục sang bước Thiết kế.",
      "selectAll": "Chọn tất cả",
      "clearAll": "Bỏ chọn tất cả",
      "enabledCount": "Đang bật {{count}}/{{total}}",
      "minOneRequired": "Cần bật ít nhất 1 biến thể để tiếp tục.",
      "trackOn": "Bật",
      "trackOff": "Tắt",
      "overridePlaceholder": "Ghi đè ¢",
      "required": "bắt buộc",
      "addonsTitle": "Tiện ích & phụ kiện",
      "addonsDesc": "Phụ phí tự chọn khách có thể thêm khi thanh toán.",
      "addonsLabel": "Tiện ích",
      "accessoriesLabel": "Phụ kiện",
      "giftMessage": "Cho phép khách thêm lời nhắn quà khi thanh toán",
      "col": {
        "size": "Size",
        "color": "Màu",
        "sku": "Mã SKU",
        "inventory": "Theo dõi tồn kho",
        "priceOverride": "Ghi đè (¢)",
        "customSku": "SKU tuỳ chỉnh"
      },
      "embroidery": {
        "title": "Cấu hình thêu",
        "desc": "Kiểu mũi, kích cỡ khung, và bảng chỉ thêu cho vùng thêu.",
        "stitchType": "Kiểu mũi",
        "frameSize": "Khung thêu (mm)",
        "threadColors": "Màu chỉ",
        "addColor": "+ Thêm màu",
        "closePalette": "Đóng",
        "removeColor": "Bấm để xoá",
        "stitch": {
          "flat": "Phẳng",
          "puff": "Nổi (3D)"
        },
        "threadAria": "Chỉ {{hex}}",
        "color": {
          "black": "Đen",
          "white": "Trắng",
          "red": "Đỏ",
          "royalBlue": "Xanh hoàng gia",
          "green": "Xanh lá",
          "yellow": "Vàng",
          "purple": "Tím",
          "orange": "Cam",
          "teal": "Xanh mòng két",
          "magenta": "Đỏ tươi",
          "brown": "Nâu",
          "silver": "Bạc",
          "gold": "Vàng kim",
          "pink": "Hồng"
        }
      },
      "customSkuDup": "Custom SKU bị trùng — phải là duy nhất trong sản phẩm.",
      "customSkuHint": "Không bắt buộc. Để trống để dùng lại SKU hệ thống khi khớp đơn hàng.",
      "personalized": "Sản phẩm personalized — mỗi đơn hàng phải upload artwork mới",
      "axisUnresolved": "Không đọc được tuỳ chọn {{axis}} của blueprint này nên hệ thống dùng giá trị tạm. Đơn hàng cho các biến thể này có thể không tính được giá — hãy nhờ admin kiểm tra lại tuỳ chọn của blueprint."
    },
    "step3": {
      "heading": "Thêm mockup",
      "desc": "Tải lên tối đa 10 ảnh sản phẩm và chọn một ảnh làm ảnh chính.",
      "dropzone": "Nhấp hoặc kéo ảnh vào đây để tải lên",
      "maxReached": "Đã đạt tối đa 10 ảnh",
      "mainBadge": "Ảnh chính",
      "remove": "Xoá ảnh",
      "setMain": "Đặt làm ảnh chính",
      "noBlueprint": "Vui lòng chọn blueprint ở Bước 1 trước.",
      "loadFailed": "Không tải được vùng in.",
      "noMockup": "Chưa có mockup để xem trước.",
      "dropHint": "Kéo & thả artwork vào đây",
      "dropSubhint": "PNG · JPG · SVG · tối đa 25 MB",
      "uploadCta": "Tải file lên",
      "libraryCta": "Chọn từ thư viện",
      "validatingHint": "Đang chạy kiểm tra thiết kế…",
      "replace": "Thay thế",
      "bulkUpload": "Tải hàng loạt",
      "mockupAlt": "Mockup sản phẩm với vùng in",
      "summary": {
        "passed": "đạt",
        "failed": "lỗi",
        "inProgress": "đang xử lý"
      },
      "state": {
        "pending": "Chờ",
        "uploading": "Đang tải…",
        "validating": "Đang kiểm tra…",
        "passed": "Đạt",
        "failed": "Lỗi"
      },
      "errors": {
        "unsupportedMime": "Chỉ hỗ trợ PNG, JPG hoặc SVG.",
        "tooLarge": "File quá lớn. Tối đa 25 MB."
      },
      "libraryLoadFailed": "Không tải được thư viện của bạn. Vui lòng thử lại.",
      "libraryTitle": "Chọn từ thư viện",
      "libraryEmpty": "Thư viện của bạn đang trống.",
      "libraryEmptyHint": "Tải lên một file ở khu vực kéo-thả bên dưới — lần sau nó sẽ xuất hiện ở đây."
    },
    "step4": {
      "heading": "Đặt giá bán theo từng cửa hàng",
      "desc": "Hệ thống luôn thanh toán bằng USD. Ô có biên lợi nhuận âm sẽ bôi đỏ.",
      "noBlueprint": "Vui lòng chọn blueprint ở Bước 1 trước.",
      "noStores": "Hãy chọn ít nhất 1 cửa hàng ở Bước 1.5 để đặt giá.",
      "noVariants": "Hãy bật ít nhất 1 biến thể ở Bước 2 để đặt giá.",
      "col": {
        "variant": "Biến thể",
        "cost": "Giá vốn"
      },
      "priceLabel": "Giá bán cho {{variant}} tại {{store}}",
      "negativeMargin": "Lỗ",
      "noCost": "Chưa có giá vốn",
      "summaryTitle": "Tóm tắt giá",
      "summaryDesc": "Theo dõi biên lợi nhuận khi nhập giá. Đơn vị thanh toán là USD.",
      "completion": "Số ô đã nhập",
      "negativeCells": "Ô lỗ",
      "minMargin": "Lợi nhuận thấp nhất",
      "avgMargin": "Lợi nhuận trung bình",
      "maxMargin": "Lợi nhuận cao nhất",
      "worstCell": "Cảnh báo lỗ",
      "usdNote": "USD là đơn vị thanh toán chuẩn. Tiền tệ hiển thị chỉ tham khảo."
    },
    "step5": {
      "heading": "Xem lại và đăng sản phẩm",
      "desc": "Kiểm tra lại từng bước trước khi đăng — đồng bộ tới cửa hàng sẽ chạy ngay.",
      "edit": "Sửa",
      "saveDraft": "Lưu nháp",
      "saving": "Đang lưu…",
      "publish": "Đăng sản phẩm",
      "draftSavedToast": "Đã lưu nháp",
      "publishSuccess": "Sản phẩm đã được đăng — đang đồng bộ tới cửa hàng.",
      "publishError": "Không đăng được sản phẩm.",
      "productInfoTitle": "Thông tin sản phẩm",
      "titleLabel": "Tên sản phẩm",
      "descLabel": "Mô tả",
      "tagsLabel": "Thẻ",
      "tagPlaceholder": "Nhập thẻ rồi nhấn Enter",
      "removeTag": "Xoá thẻ {{tag}}",
      "platformFieldsTitle": "Thông tin theo nền tảng",
      "noPlatformFields": "Chưa chọn cửa hàng — quay lại Bước 1.5.",
      "tagsPlaceholder": "Cách nhau bằng dấu phẩy",
      "cards": {
        "blueprint": "Blueprint",
        "stores": "Đăng tới cửa hàng",
        "variants": "Biến thể",
        "artwork": "Thiết kế",
        "pricing": "Giá",
        "noBlueprint": "Chưa chọn blueprint.",
        "noStores": "Chưa chọn cửa hàng.",
        "connected": "Đã kết nối",
        "pending": "Đang chờ",
        "variantsCount": "Đang bật {{count}}/{{total}}",
        "artworkCount": "{{passed}}/{{total}} vùng đã đạt",
        "pricingCount": "{{count}} ô đã có giá",
        "mockup": "Mockup",
        "mainSet": "đã chọn",
        "mainMissing": "chưa chọn",
        "mockupEmpty": "Chưa tải ảnh nào",
        "mockupCount": "{{count}} ảnh · ảnh chính {{main}}"
      },
      "publishConfirm": {
        "title": "Đăng sản phẩm?",
        "desc": "Hệ thống sẽ tạo sản phẩm và đẩy job đồng bộ tới các cửa hàng đã chọn.",
        "product": "Sản phẩm",
        "untitled": "(chưa đặt tên)",
        "stores": "Đồng bộ tới",
        "pricing": "Giá",
        "pricingCount": "{{count}}/{{total}} ô đã có giá",
        "syncWarning": "Job đồng bộ chạy bất đồng bộ — ID sàn sẽ xuất hiện trong My Products khi cửa hàng phản hồi.",
        "cancel": "Huỷ",
        "publishing": "Đang đăng…",
        "confirm": "Đăng"
      },
      "fields": {
        "etsy": {
          "tags": "Thẻ Etsy (tối đa 13)",
          "materials": "Nguyên liệu",
          "whoMade": "Ai sản xuất",
          "whenMade": "Thời điểm sản xuất"
        },
        "amazon": {
          "category": "Danh mục",
          "keywords": "Từ khoá",
          "brand": "Thương hiệu"
        },
        "tiktok": {
          "weight": "Trọng lượng (g)",
          "shippingCategory": "Loại vận chuyển"
        },
        "shopify": {
          "seoTitle": "SEO title",
          "seoDescription": "SEO description"
        },
        "woo": {
          "taxClass": "Lớp thuế",
          "weight": "Trọng lượng (g)"
        },
        "generic": {
          "notes": "Ghi chú"
        }
      }
    },
    "draft": {
      "idle": "Sẵn sàng tự lưu",
      "saving": "Đang lưu…",
      "savedAt": "Đã lưu lúc {{ts}}",
      "localOnly": "Đã lưu cục bộ",
      "resumeTitle": "Tiếp tục bản nháp?",
      "resumeDesc": "Chúng tôi đã lưu phần làm dở của bạn. Bạn có thể tiếp tục hoặc bắt đầu lại.",
      "resumeLastSaved": "Lần lưu gần nhất {{when}}",
      "resumeConfirm": "Tiếp tục",
      "resumeDiscard": "Bắt đầu lại",
      "toastSaved": "Đã lưu nháp lên server",
      "toastNoBlueprint": "Chưa thể lưu nháp — chọn blueprint ở bước 1 trước.",
      "toastError": "Lưu lên server thất bại — bản nháp đã lưu cục bộ",
      "resumed": "Đã mở lại bản nháp"
    },
    "breadcrumbEdit": "Sản phẩm của tôi / Chỉnh sửa sản phẩm",
    "pageTitleEdit": "Chỉnh sửa sản phẩm"
  },
  "settings": {
    "title": "Cài đặt sản phẩm",
    "subtitle": "Cấu hình mặc định cho sản phẩm của bạn.",
    "back": "Sản phẩm của tôi",
    "save": "Lưu thay đổi",
    "saving": "Đang lưu…",
    "savedAt": "Đã lưu lúc {{ts}}",
    "pricing": {
      "title": "Giá mặc định",
      "subtitle": "Áp dụng cho sản phẩm mới khi chưa nhập giá riêng.",
      "margin": "Biên lợi nhuận mặc định",
      "marginHint": "Áp dụng vào tính giá bán cho sản phẩm mới.",
      "currency": "Tiền tệ hiển thị",
      "currencyHint": "Đơn vị thanh toán vẫn là USD.",
      "autoSku": "Tự sinh SKU",
      "autoSkuHint": "Tự động tạo mã SKU khi tạo sản phẩm mới."
    },
    "printMethod": {
      "title": "Phương thức in mặc định",
      "subtitle": "Cấu hình mặc định cho artwork & in.",
      "method": "Phương thức in",
      "minDpi": "DPI tối thiểu",
      "minDpiHint": "Artwork dưới ngưỡng này sẽ bị từ chối.",
      "maxFile": "Kích thước file tối đa",
      "formats": "Định dạng cho phép",
      "formatsHint": "Bấm để bật/tắt từng định dạng.",
      "autoResize": "Tự động co ảnh",
      "autoResizeHint": "Resize artwork về vùng in khi tải lên.",
      "options": {
        "dtg": "DTG (in trực tiếp)",
        "dtf": "DTF (chuyển nhiệt phim)",
        "sublimation": "Sublimation",
        "embroidery": "Thêu",
        "screen_print": "In lụa"
      }
    },
    "shipping": {
      "title": "Vận chuyển mặc định",
      "subtitle": "Cấu hình điểm xuất phát + đồng bộ kho.",
      "origin": "Quốc gia xuất phát",
      "leadTime": "Thời gian xử lý (ngày)",
      "autoSync": "Tự động đồng bộ sang cửa hàng",
      "autoSyncHint": "Sản phẩm mới đăng sẽ được đẩy ngay tới các cửa hàng đã kết nối."
    },
    "notifications": {
      "title": "Thông báo",
      "subtitle": "Bật/tắt cảnh báo cho từng sự kiện sản phẩm.",
      "event": "Sự kiện",
      "email": "Email",
      "inApp": "Trên ứng dụng",
      "events": {
        "productPublished": "Sản phẩm đã đăng",
        "productSyncFailed": "Đồng bộ sản phẩm thất bại",
        "productOutOfStock": "Sản phẩm hết hàng",
        "bulkImportFinished": "Hoàn tất nhập hàng loạt"
      }
    },
    "aria": {
      "emailEvent": "Email {{event}}",
      "inAppEvent": "Trong ứng dụng {{event}}"
    }
  },
  "wizardDrafts": {
    "breadcrumb": "Sản phẩm / Đang biên soạn",
    "title": "Bản nháp đang biên soạn",
    "hint": "Các bản nháp được tự động lưu khi bạn đang tạo sản phẩm. Tự xoá sau 30 ngày không cập nhật.",
    "empty": "Chưa có bản nháp nào.",
    "startNew": "Tạo sản phẩm mới",
    "untitled": "Chưa đặt tên",
    "resume": "Mở lại",
    "confirmDelete": "Xoá bản nháp này?",
    "deleted": "Đã xoá bản nháp",
    "deleteFailed": "Xoá bản nháp thất bại",
    "col": {
      "product": "Sản phẩm",
      "blueprint": "Blueprint",
      "progress": "Tiến độ",
      "savedAt": "Lưu lúc",
      "expiresAt": "Hết hạn"
    },
    "relative": {
      "expiringSoon": "sắp hết hạn",
      "oneDayLeft": "còn 1 ngày",
      "daysLeft": "còn {{days}} ngày"
    }
  },
  "catalog": {
    "cta": {
      "wizardDrafts": "Đang biên soạn ({{count}})"
    }
  }
}
